import { lazy } from 'react';

export const componentRegistry: Record<string, ReturnType<typeof lazy>> = {
    '@dcentralexpedientedigital/fe-casino/components/auth-required-actions': lazy(() =>
        import('./components/auth-required-actions').then(({ AuthRequiredActions }) => ({
            default: AuthRequiredActions,
        })),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/button/button': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/button/button').then(
            ({ Button }) => ({
                default: Button,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/banner/banner/banner': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/banner/banner/banner').then(
            ({ Banner }) => ({
                default: Banner,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shop/shop-banner/shop-banner': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shop/shop-banner/shop-banner').then(
            ({ ShopBanner }) => ({
                default: ShopBanner,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shop/inventory-list/inventory-list': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shop/inventory-list/inventory-list').then(
            ({ InventoryList }) => ({
                default: InventoryList,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-casino/components/shop': lazy(() =>
        import('./components/shop').then(({ Shop }) => ({
            default: Shop,
        })),
    ),
    '@dcentralexpedientedigital/fe-ui/components/rewards/rewards': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/rewards/rewards').then(
            ({ Rewards }) => ({
                default: Rewards,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/account-banner/account-banner': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/account-banner/account-banner').then(
            ({ AccountBanner }) => ({
                default: AccountBanner,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/lobby/lobby': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/lobby/lobby').then(({ Lobby }) => ({
            default: Lobby,
        })),
    ),
    '@dcentralexpedientedigital/fe-ui/components/modal-popup/modal-popup': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/modal-popup/modal-popup').then(
            ({ ModalPopup }) => ({
                default: ModalPopup,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/block-layout/block-layout': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/block-layout/block-layout').then(
            ({ BlockLayout }) => ({
                default: BlockLayout,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/balance-display/balance-display': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/balance-display/balance-display').then(
            ({ BalanceDisplay }) => ({
                default: BalanceDisplay,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/login-iframe/login-iframe': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/login-iframe/login-iframe').then(
            ({ LoginIframe }) => ({
                default: LoginIframe,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/logged-out-landing/logged-out-landing': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/logged-out-landing/logged-out-landing').then(
            ({ LoggedOutLanding }) => ({
                default: LoggedOutLanding,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/forms/sign-up-form/sign-up-form': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/forms/sign-up-form/sign-up-form').then(
            ({ SignUpForm }) => ({
                default: SignUpForm,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/sign-up-success/sign-up-success': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/sign-up-success/sign-up-success').then(
            ({ SignUpSuccess }) => ({
                default: SignUpSuccess,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/bottom-nav/bottom-nav': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/bottom-nav/bottom-nav').then(
            ({ BottomNav }) => ({
                default: BottomNav,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-casino/components/sidebar': lazy(() =>
        import('./components/sidebar').then(({ Sidebar }) => ({
            default: Sidebar,
        })),
    ),
    '@dcentralexpedientedigital/fe-casino/components/logout': lazy(() =>
        import('./components/logout').then(({ Logout }) => ({
            default: Logout,
        })),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/image/image': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/image/image').then(
            ({ Image }) => ({
                default: Image,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/text-block/text-block': lazy(
        () =>
            import('@dcentralexpedientedigital/fe-ui/components/shared/components/text-block/text-block').then(
                ({ TextBlock }) => ({
                    default: TextBlock,
                }),
            ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/heading/heading': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/heading/heading').then(
            ({ Heading }) => ({
                default: Heading,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/text-line/text-line': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/text-line/text-line').then(
            ({ TextLine }) => ({
                default: TextLine,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/game/layout/game-layout': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/game/layout/game-layout').then(
            ({ GameLayout }) => ({
                default: GameLayout,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/footer/atoms/faqs/faqs': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/footer/atoms/faqs/faqs').then(
            ({ FAQs }) => ({
                default: FAQs,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/hero/hero': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/hero/hero').then(
            ({ Hero }) => ({
                default: Hero,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/icon-row/icon-row': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/icon-row/icon-row').then(
            ({ IconRow }) => ({
                default: IconRow,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/logo/container/logo-container':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/shared/components/logo/container/logo-container').then(
                ({ LogoContainer }) => ({
                    default: LogoContainer,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/text-and-image/text-and-image':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/text-and-image/text-and-image').then(
                ({ TextAndImage }) => ({
                    default: TextAndImage,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/jackpot-banner/jackpot-banner': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/jackpot-banner/jackpot-banner').then(
            ({ JackpotBanner }) => ({
                default: JackpotBanner,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/jackpot-wins/jackpot-wins': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/jackpot-wins/jackpot-wins').then(
            ({ JackpotWins }) => ({
                default: JackpotWins,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/slider-banner/slider-banner':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/slider-banner/slider-banner').then(
                ({ SliderBanner }) => ({
                    default: SliderBanner,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/card-grid/card-grid': lazy(
        () =>
            import('@dcentralexpedientedigital/fe-ui/components/dynamic-content-page/card-grid/card-grid').then(
                ({ CardGrid }) => ({
                    default: CardGrid,
                }),
            ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/lobby/category-cards/category-cards': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/lobby/category-cards/category-cards').then(
            ({ CategoryCards }) => ({
                default: CategoryCards,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/lobby/providers-list/providers-list': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/lobby/providers-list/providers-list').then(
            ({ ProvidersList }) => ({
                default: ProvidersList,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/lobby/lobby-header/lobby-header': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/lobby/lobby-header/lobby-header').then(
            ({ LobbyHeader }) => ({
                default: LobbyHeader,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/breadcrumb-navigator/breadcrumb-navigator': lazy(
        () =>
            import('@dcentralexpedientedigital/fe-ui/components/breadcrumb-navigator/breadcrumb-navigator').then(
                ({ BreadcrumbNavigator }) => ({
                    default: BreadcrumbNavigator,
                }),
            ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/status-message/status-message': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/status-message/status-message').then(
            ({ StatusMessage }) => ({
                default: StatusMessage,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/status-page/status-page': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/status-page/status-page').then(
            ({ StatusPage }) => ({
                default: StatusPage,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/footer/atoms/locale-selector/locale-selector':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/footer/atoms/locale-selector/locale-selector').then(
                ({ LocaleSelector }) => ({
                    default: LocaleSelector,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/footer/atoms/footer-logos/footer-logos': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/footer/atoms/footer-logos/footer-logos').then(
            ({ FooterLogos }) => ({
                default: FooterLogos,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/footer/atoms/footer-links-wrapper/footer-links-wrapper':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/footer/atoms/footer-links-wrapper/footer-links-wrapper').then(
                ({ FooterLinksWrapper }) => ({
                    default: FooterLinksWrapper,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/footer/atoms/footer-links/footer-links': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/footer/atoms/footer-links/footer-links').then(
            ({ FooterLinks }) => ({
                default: FooterLinks,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/refresh-session/refresh-session': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/refresh-session/refresh-session').then(
            ({ RefreshSession }) => ({
                default: RefreshSession,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/tab-navigator/tab-navigator': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/tab-navigator/tab-navigator').then(
            ({ TabNavigator }) => ({
                default: TabNavigator,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/history/my-account-history': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/my-account/history/my-account-history').then(
            ({ MyAccountHistory }) => ({
                default: MyAccountHistory,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/history/components/history-wizard/history-wizard':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/history/components/history-wizard/history-wizard').then(
                ({ HistoryWizard }) => ({
                    default: HistoryWizard,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/bonuses/containers/bonus-section': lazy(
        () =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/bonuses/containers/bonus-section').then(
                ({ BonusSection }) => ({
                    default: BonusSection,
                }),
            ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-profile/user-profile':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-profile/user-profile').then(
                ({ UserProfile }) => ({
                    default: UserProfile,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-password-change/user-password-change':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-password-change/user-password-change').then(
                ({ UserPasswordChange }) => ({
                    default: UserPasswordChange,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-password-change-iframe/user-password-change-iframe':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-password-change-iframe/user-password-change-iframe').then(
                ({ UserPasswordChangeIframe }) => ({
                    default: UserPasswordChangeIframe,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-documents/user-documents':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-documents/user-documents').then(
                ({ UserDocuments }) => ({
                    default: UserDocuments,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-responsible-gaming/user-responsible-gaming':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-responsible-gaming/user-responsible-gaming').then(
                ({ UserResponsibleGaming }) => ({
                    default: UserResponsibleGaming,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-self-exclusion/user-self-exclusion':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-self-exclusion/user-self-exclusion').then(
                ({ UserSelfExclusion }) => ({
                    default: UserSelfExclusion,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-preferences/user-preferences':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-preferences/user-preferences').then(
                ({ UserPreferences }) => ({
                    default: UserPreferences,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-profile-edit/user-profile-edit':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-profile-edit/user-profile-edit').then(
                ({ UserProfileEdit }) => ({
                    default: UserProfileEdit,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/responsible-gaming-budget-form/responsible-gaming-budget-form':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/responsible-gaming-budget-form/responsible-gaming-budget-form').then(
                ({ ResponsibleGamingBudgetForm }) => ({
                    default: ResponsibleGamingBudgetForm,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/responsible-gaming-budget-history/responsible-gaming-budget-history':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/responsible-gaming-budget-history/responsible-gaming-budget-history').then(
                ({ ResponsibleGamingBudgetHistory }) => ({
                    default: ResponsibleGamingBudgetHistory,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-self-exclusion-form/user-self-exclusion-form':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-self-exclusion-form/user-self-exclusion-form').then(
                ({ UserSelfExclusionForm }) => ({
                    default: UserSelfExclusionForm,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-self-exclusion-history/user-self-exclusion-history':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-self-exclusion-history/user-self-exclusion-history').then(
                ({ UserSelfExclusionHistory }) => ({
                    default: UserSelfExclusionHistory,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/responsible-gaming-session-form/responsible-gaming-session-form':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/responsible-gaming-session-form/responsible-gaming-session-form').then(
                ({ ResponsibleGamingSessionForm }) => ({
                    default: ResponsibleGamingSessionForm,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-kyc-upload-document/user-kyc-upload-document':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-kyc-upload-document/user-kyc-upload-document').then(
                ({ KycDocumentUpload }) => ({
                    default: KycDocumentUpload,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/kyc/components/sumsub/sumsub': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/kyc/components/sumsub/sumsub').then(
            ({ SumSub }) => ({
                default: SumSub,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/promotions/components/promotion-card-list/promotion-card-list':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/promotions/components/promotion-card-list/promotion-card-list').then(
                ({ PromotionCardList }) => ({
                    default: PromotionCardList,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/divider/divider': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/divider/divider').then(
            ({ Divider }) => ({
                default: Divider,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/promotion-details/promotion-details': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/promotion-details/promotion-details').then(
            ({ PromotionDetails }) => ({
                default: PromotionDetails,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/sportsbook/components/altenar/altenar': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/sportsbook/components/altenar/altenar').then(
            ({ Altenar }) => ({
                default: Altenar,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/cashier/container/cashier': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/cashier/container/cashier').then(
            ({ Cashier }) => ({
                default: Cashier,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/toaster/toaster': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/toaster/toaster').then(
            ({ Toaster }) => ({
                default: Toaster,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/side-menu-navigation/components/side-menu-navigation-collection/side-menu-navigation-collection':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/side-menu-navigation/components/side-menu-navigation-collection/side-menu-navigation-collection').then(
                ({ SideMenuNavigationCollection }) => ({
                    default: SideMenuNavigationCollection,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/clock-time/clock-time': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/clock-time/clock-time').then(
            ({ ClockTime }) => ({
                default: ClockTime,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/gap/gap': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/gap/gap').then(
            ({ Gap }) => ({
                default: Gap,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/side-menu-navigation/components/side-menu-switcher-manager/side-menu-switcher-manager':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/side-menu-navigation/components/side-menu-switcher-manager/side-menu-switcher-manager').then(
                ({ SideMenuSwitcherManager }) => ({
                    default: SideMenuSwitcherManager,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/top-nav/components/menu/menu': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/top-nav/components/menu/menu').then(
            ({ Menu }) => ({
                default: Menu,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/inline-search-bar/inline-search-bar': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/inline-search-bar/inline-search-bar').then(
            ({ InlineSearchBar }) => ({
                default: InlineSearchBar,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/button-search-bar/button-search-bar': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/button-search-bar/button-search-bar').then(
            ({ ButtonSearchBar }) => ({
                default: ButtonSearchBar,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/inpage-search-bar/inpage-search-bar': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/inpage-search-bar/inpage-search-bar').then(
            ({ InpageSearchBar }) => ({
                default: InpageSearchBar,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/mobile-navigation/components/display-name/display-name':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/mobile-navigation/components/display-name/display-name').then(
                ({ DisplayName }) => ({
                    default: DisplayName,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/gamification/player-level-progress/player-level-progress':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/gamification/player-level-progress/player-level-progress').then(
                ({ PlayerLevelProgress }) => ({
                    default: PlayerLevelProgress,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/gamification/player-progress/player-progress':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/gamification/player-progress/player-progress').then(
                ({ PlayerProgress }) => ({
                    default: PlayerProgress,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/gamification/player-loyalty-coins/player-loyalty-coins':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/gamification/player-loyalty-coins/player-loyalty-coins').then(
                ({ PlayerLoyaltyCoins }) => ({
                    default: PlayerLoyaltyCoins,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/gamification/gamification-widget/gamification-widget':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/gamification/gamification-widget/gamification-widget').then(
                ({ GamificationWidget }) => ({
                    default: GamificationWidget,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/top-nav/components/logged-in-actions/logged-in-actions':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/top-nav/components/logged-in-actions/logged-in-actions').then(
                ({ LoggedInActions }) => ({
                    default: LoggedInActions,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/top-nav/components/logged-out-actions/logged-out-actions':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/top-nav/components/logged-out-actions/logged-out-actions').then(
                ({ LoggedOutActions }) => ({
                    default: LoggedOutActions,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/shared/components/link/link': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shared/components/link/link').then(
            ({ Link }) => ({
                default: Link,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/mobile-navigation/components/wallet-cards/wallet-cards':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/mobile-navigation/components/wallet-cards/wallet-cards').then(
                ({ WalletCards }) => ({
                    default: WalletCards,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/shop/coin-balance/coin-balance': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/shop/coin-balance/coin-balance').then(
            ({ CoinBalance }) => ({
                default: CoinBalance,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/container/container': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/container/container').then(
            ({ Container }) => ({
                default: Container,
            }),
        ),
    ),
    '@dcentralexpedientedigital/fe-ui/components/top-nav/components/mobile-balance/mobile-balance':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/top-nav/components/mobile-balance/mobile-balance').then(
                ({ MobileBalance }) => ({
                    default: MobileBalance,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/bonus-selector/bonus-selector-button/bonus-selector-button':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/bonus-selector/bonus-selector-button/bonus-selector-button').then(
                ({ BonusSelectorButton }) => ({
                    default: BonusSelectorButton,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-kyc-upload-method-selector/user-kyc-upload-method-selector':
        lazy(() =>
            import('@dcentralexpedientedigital/fe-ui/components/my-account/profile/components/user-kyc-upload-method-selector/user-kyc-upload-method-selector').then(
                ({ KycDocumentUploadMethodSelector }) => ({
                    default: KycDocumentUploadMethodSelector,
                }),
            ),
        ),
    '@dcentralexpedientedigital/fe-ui/components/redirect/first-link-in-menu': lazy(() =>
        import('@dcentralexpedientedigital/fe-ui/components/redirect/first-link-in-menu').then(
            ({ FirstLinkInMenu }) => ({
                default: FirstLinkInMenu,
            }),
        ),
    ),
};
